import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.router.navigate(['/home'])
    }, 600); 
    if (!localStorage.getItem('up')) {
      localStorage.setItem('up', 'no reload')
      location.reload()
    } else {
      localStorage.removeItem('up')
    }
  }

}
